import React from 'react';
import '../forms.css';
import { systemText } from '../../../helpers/string';
import FormLabel from '../formLabel';
import uuid from 'uuid/v4';

const Toggle = props => {
	const onChange = value => {
		if (typeof props.onChange === 'function') {
			props.onChange(value);
		}
	};

	const checkSubmit = e => {
		if (e.key === 'Enter' && typeof props.onSubmit === 'function') {
			props.onSubmit();
		}
	};

	const { label, help, error, warning, id, value, yesLabel, noLabel, disabled, readonly, ...rest } = props;

	const guid = uuid();

	const yes = value ? 'btn-primary' : 'btn-default';
	const no = !value ? 'btn-primary' : 'btn-default';

	const hideIcons = yesLabel || noLabel;

	const defaultYes = systemText('Admin/Forms/Toggle/Yes');
	const defaultNo = systemText('Admin/Forms/Toggle/No');

	const safeId = id || props['data-testid'];

	return (
		<div
			key={safeId}
			id={safeId}
			role="radiogroup"
			aria-labelledby={`label-${safeId}`}
			className={`form-group ${error ? 'has-error' : warning ? 'has-warning' : ''}`}
			data-testid={props['data-testid']}
		>
			<FormLabel {...props} />
			<div className="btn-row">
				<div
					role="radio"
					aria-checked={value}
					id={`buttons-${safeId || guid}`}
					disabled={disabled || readonly}
					tabIndex={disabled ? -1 : 0}
					className={`btn ${yes}`}
					onClick={disabled ? null : () => onChange(true)}
					onKeyDown={e => e.code === 'Space' && onChange(true)}
				>
					{!hideIcons && <i className="fa fa-thumbs-up" />} {yesLabel ? yesLabel : defaultYes}
				</div>
				<div
					role="radio"
					aria-checked={!value}
					id={`buttons-${safeId || guid}`}
					tabIndex={disabled ? -1 : 0}
					disabled={disabled || readonly}
					className={`btn ${no}`}
					onClick={disabled ? null : () => onChange(false)}
					onKeyDown={e => e.code === 'Space' && onChange(false)}
				>
					{!hideIcons && <i className="fa fa-thumbs-down" />} {noLabel ? noLabel : defaultNo}
				</div>
			</div>
			{error && <span className="help-block">{typeof error === 'function' ? error() : error}</span>}
			{warning && <span className="help-block">{typeof warning === 'function' ? warning() : warning}</span>}
		</div>
	);
};

export default Toggle;
